'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function TrainingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Training page error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6">
          <Icon
            name="ExclamationTriangleIcon"
            size={64}
            className="mx-auto text-primary mb-4"
          />
          <h1 className="text-3xl font-bold text-gradient-neon mb-2">
            Training Page Error
          </h1>
          <p className="text-muted-foreground mb-6">
            {error.message || 'Unable to load training content'}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-primary text-primary-foreground font-semibold rounded-sm hover:shadow-neon-cyan-intense transition-all duration-300"
          >
            Try again
          </button>
          <Link
            href="/home"
            className="px-6 py-3 bg-card border border-border text-foreground font-semibold rounded-sm hover:border-primary hover:shadow-neon-cyan transition-all duration-300"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}

